import * as Sentry from '@sentry/react';
import { useEffect } from 'react';

import { useAsteriskUrl } from '@/api/use-asterisk-url';
import { useUserInfo } from '@/api/use-user-info';
import { useCodWeb } from '@/hooks/use-codweb';
import { useExtension } from '@/hooks/use-extension';
import { useProvider } from '@/hooks/use-provider';

export const useSentryUserContext = () => {
  const [provider] = useProvider();
  const { data: userInfo } = useUserInfo();
  const extension = useExtension();
  const codWeb = useCodWeb();
  const { data: asteriskUrl } = useAsteriskUrl();

  useEffect(() => {
    const userContext = {
      email: '',
      extensionNumber: '',
    };

    if (userInfo?.email) {
      userContext.email = userInfo.email;
    }
    if (extension?.number) {
      userContext.extensionNumber = extension.number;
    }

    Sentry.setUser(userContext);

    if (codWeb) {
      Sentry.setTag('tenant', codWeb);
    }

    if (asteriskUrl) {
      Sentry.setContext('asterisk', {
        url: asteriskUrl,
      });
    }
  }, [provider.id, userInfo?.email, extension?.number, codWeb, asteriskUrl]);
};
